import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectWithoutAgentCall = createSelector(
  selectJsonQuery,
  jsonQuery => getTermValue('cl')(jsonQuery) === false,
);
